<template>
	<div class="more" :class="{ 'more--en': locale === 'en' }">
		<!-- 专业测算工具 -->
		<!-- <div ref="professionalToolsRef" class="box1">
			<div class="title">
				<img src="../../../images/pc/left2.png" class="pic" alt="" />
				{{ t("index.more.box1.title") }}
				<img src="../../../images/pc/right2.png" class="pic" alt="" />
			</div>
			<div class="title2">{{ t("index.more.box1.title2") }}</div>
			<ul class="tool-list">
				<li
					v-for="(item, index) in toolList"
					:key="item.id"
					:ref="el => bindToolRef(el, item, index)"
					class="tool-card"
				>
					<div class="tool-card__cover">
						<img :src="item.cover" :alt="item.title" class="tool-card__cover-img" />
					</div>
					<div class="tool-card__body">
						<div class="tool-card__title-row">
							<img :src="item.icon" alt="" class="tool-card__icon" aria-hidden="true" />
							<h3 class="tool-card__title">{{ item.title }}</h3>
						</div>
						<p class="tool-card__desc">
							<span>{{ item.desc1 }}</span>
							<span class="tool-card__divider" aria-hidden="true">|</span>
							<span>{{ item.desc2 }}</span>
						</p>
						<button class="tool-card__button" type="button" @click="handleUse(item, index)">
							{{ t("index.more.box1.useButton") }}
						</button>
					</div>
				</li>
			</ul>
		</div> -->
		<!-- 大模型预算 -->
		<div ref="aiAssessmentRef" class="box2">
			<!-- <div class="section-title">
				<img src="../../../images/pc/left4.png" class="pic3" alt="" aria-hidden="true" />
				{{ t("index.more.box2.title") }}
				<img src="../../../images/pc/right4.png" class="pic3" alt="" aria-hidden="true" />
			</div> -->
			<div class="title">
				<img src="../../../images/pc/left2.png" class="pic" alt="" />
				{{ t("index.more.box2.title") }}
				<img src="../../../images/pc/right2.png" class="pic" alt="" />
			</div>
			<div class="title2">{{ t("index.more.box1.title2") }}</div>
			<ul class="ai-tool-grid">
				<li
					v-for="(item, index) in aiToolList"
					:key="item.id"
					class="ai-tool-item"
					:class="{ 'ai-tool-item__content--en': locale === 'en' }"
					role="button"
					tabindex="0"
					@click="handleAiToolClick(item, index)"
					@keydown.enter="handleAiToolClick(item, index)"
				>
					<div class="ai-tool-item__icon">
						<img :src="item.icon" :alt="item.title" class="ai-tool-item__icon-img" />
					</div>
					<div class="ai-tool-item__content">
						<h3 class="ai-tool-item__title">
							{{ item.title }}
							<img src="../../../images/pc/guide.png" alt="" class="arrow" />
						</h3>
						<p class="ai-tool-item__desc">
							<span>{{ item.desc1 }}</span>
							<span>{{ item.desc2 }}</span>
						</p>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useI18n } from "~/composables/useI18n";
import {
	useHomepageTracking,
	useSectionView,
	useToolCardImpression,
} from "@variants/index/composables/useHomepageTracking";
import { useAppDownloadModal } from "~/composables/useAppDownloadModal";
import bazi from "../../../images/pc/bazi.jpg";
import tarot from "../../../images/pc/taluo.jpg";
import baziIcon from "../../../images/pc/bazi2.png";
import tarotIcon from "../../../images/pc/tarot2.png";
import more1 from "../../../images/pc/more1.png";
import more2 from "../../../images/pc/more2.png";
import more3 from "../../../images/pc/more3.png";
import more4 from "../../../images/pc/more4.png";
import more5 from "../../../images/pc/more5.png";
import more6 from "../../../images/pc/more6.png";
import more7 from "../../../images/pc/more7.png";
import more8 from "../../../images/pc/more8.png";
import more9 from "../../../images/pc/more9.png";

const { t, locale } = useI18n();
const { track } = useHomepageTracking("pc");
const { openAppDownloadModal } = useAppDownloadModal();
const professionalToolsRef = ref(null);
const aiAssessmentRef = ref(null);
const { bindToolRef } = useToolCardImpression({ track });

useSectionView(professionalToolsRef, {
	track,
	sectionId: "professional_tools",
});

useSectionView(aiAssessmentRef, {
	track,
	sectionId: "ai_assessment",
});

const toolList = computed(() => [
	{
		id: "bazi",
		cover: bazi,
		icon: baziIcon,
		title: t("index.more.box1.bazi.title"),
		desc1: t("index.more.box1.bazi.desc1"),
		desc2: t("index.more.box1.bazi.desc2"),
	},
	{
		id: "tarot",
		cover: tarot,
		icon: tarotIcon,
		title: t("index.more.box1.tarot.title"),
		desc1: t("index.more.box1.tarot.desc1"),
		desc2: t("index.more.box1.tarot.desc2"),
	},
]);

function handleUse(item, index) {
	track("tool_card_click", {
		tool_type: item.id,
		tool_name: item.title,
		position: index + 1,
	});
	openAppDownloadModal();
}

function handleAiToolClick(item, index) {
	if (item.id === "more") {
		track("more_assessment_click", {
			section_id: "ai_assessment",
		});
	} else {
		track("ai_assessment_click", {
			assessment_type: item.id,
			assessment_name: item.title,
			position: index + 1,
		});
	}

	const category = AI_TOOL_CATEGORIES[item.id];
	navigateTo(category ? `/seer/tests?category=${category}` : "/seer/tests");
}

const AI_TOOL_KEYS = [
	"love",
	"career",
	"wealth",
	"annual",
	"ziwei",
	"bazi",
	"tarot",
	"more",
	"funTest",
];

/** 首页入口对应更多测试页分类 Tab */
const AI_TOOL_CATEGORIES = {
	love: "danrenyinyuan",
	career: "shiye",
	wealth: "shiye",
	annual: "liunian",
	ziwei: "zonghe",
	bazi: "bazixiangpi",
	tarot: "tarot",
	more: "other",
	funTest: "fun_test",
};

const AI_TOOL_ICONS = {
	love: more1,
	career: more2,
	wealth: more3,
	annual: more4,
	ziwei: more5,
	bazi: more6,
	tarot: more7,
	more: more8,
	funTest: more9,
};

const AI_TOOL_ICON_BG = {
	love: "#fff0f3",
	career: "#eef5ff",
	wealth: "#fff8e8",
	annual: "#fff4eb",
	ziwei: "#f5f0ff",
	bazi: "#fff4eb",
	tarot: "#f5f0ff",
	funTest: "#eef8ff",
	more: "#fff8e8",
};

const aiToolList = computed(() =>
	AI_TOOL_KEYS.map(key => ({
		id: key,
		icon: AI_TOOL_ICONS[key],
		iconBg: AI_TOOL_ICON_BG[key],
		title: t(`index.more.box2.items.${key}.title`),
		desc1: t(`index.more.box2.items.${key}.desc1`),
		desc2: t(`index.more.box2.items.${key}.desc2`),
	}))
);
</script>

<style lang="scss" scoped>
.more {
	margin-top: 120px;
	.title {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 20px;
		font-size: 32px;
		color: #333333;
		font-weight: bold;

		.pic {
			width: 120px;
			height: 16px;
		}
	}

	.title2 {
		font-size: 24px;
		color: #333333;
		text-align: center;
		margin: 10px 0 80px;
	}

	.box1 {
		width: 100%;
		margin-bottom: 40px;
	}

	.tool-list {
		display: flex;
		gap: 50px;
		margin: 0;
		padding: 0 9px;
		list-style: none;
	}

	.tool-card {
		flex: 1;
		min-width: 0;
		display: flex;
		flex-direction: column;
		background: #ffffff;
		border-radius: 16px;
		box-shadow:
			0 4px 9px 0 rgba(153, 153, 153, 0.2),
			0 -4px 9px 0 rgba(153, 153, 153, 0.2);
		overflow: hidden;

		&__cover {
			width: 100%;
			aspect-ratio: 16 / 9;
			overflow: hidden;
		}

		&__cover-img {
			display: block;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		&__body {
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 24px 28px 32px;
		}

		&__title-row {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 8px;
		}

		&__icon {
			width: 24px;
			height: 24px;
			flex-shrink: 0;
			object-fit: contain;
		}

		&__title {
			margin: 0;
			font-size: 28px;
			line-height: 32px;
			color: #333333;
			font-weight: bold;
		}

		&__desc {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-wrap: wrap;
			gap: 8px;
			margin: 12px 0 40px;
			font-size: 24px;
			line-height: 24px;
			color: #666666;
			text-align: center;
		}

		&__divider {
			color: #e8e8e8;
		}

		&__button {
			margin-top: auto;
			width: 319px;
			height: 64px;
			border: 0;
			border-radius: 10px;
			background: #f2af19;
			font-size: 24px;
			line-height: 64px;
			color: #ffffff;
			cursor: pointer;

			&:hover {
				opacity: 0.7;
			}
		}
	}

	.section-title {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 16px;
		margin-bottom: 60px;
		font-size: 32px;
		line-height: 48px;
		color: #333333;
		font-weight: bold;

		.pic3 {
			width: 250px;
			height: 18px;
			flex-shrink: 0;
		}
	}

	.box2 {
		width: 100%;
		padding-top: 20px;
	}

	.ai-tool-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 24px 32px;
		margin: 0;
		padding: 0;
		list-style: none;
	}

	.ai-tool-item {
		display: flex;
		align-items: center;
		gap: 16px;
		min-width: 0;
		cursor: pointer;
		margin: 0 auto 40px;

		&__content--en {
			margin-left: 0;
			margin-right: 0;
		}

		&__icon {
			flex-shrink: 0;
			width: 90px;
			height: 90px;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;
		}

		&__icon-img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}

		&__content {
			flex: 1;
			min-width: 0;
		}

		&__title {
			display: flex;
			align-items: center;
			gap: 4px;
			margin-bottom: 10px;
			font-size: 24px;
			line-height: 30px;
			color: #333333;
			font-weight: 600;

			.arrow {
				width: 26px;
				height: 26px;
			}
		}

		&__arrow {
			font-size: 18px;
			line-height: 1;
			color: #333333;
		}

		&__desc {
			display: flex;
			flex-direction: column;

			font-size: 18px;
			color: #666666;
		}

		&__divider {
			color: #d9d9d9;
		}
	}

	&--en {
		.ai-tool-item__title {
			font-size: 16px;
			line-height: 22px;
		}

		.ai-tool-item__desc {
			font-size: 13px;
		}
	}
}
</style>
